import React from "react";
import { Button} from "antd";
import Table from 'atoms/Table';
import styled from "@emotion/styled";
import { getRoleList } from "redux/selectors";
import { connect } from "react-redux";

const StyledButton = styled(Button)`
  background: #26A4FF;
  border-radius: 5px;
  color: #FFFFFF;
  width: 100px;
  font-weight: bold;
`;

const StyledButtons = styled(Button)`
  background: #26A4FF;
  border-radius: 5px;
  color: #FFFFFF;
  width: 150px;
  font-weight: bold;
`;
const SelectTable = ({
  step,
  setStep,
  columns,
  tabledata,
  submit,
  setCreate,
  setOpenModal,
  Name,
  selectedRoleId,
  selectedBaseLocation,
  disable
}) => {

  const customLocale = {
    emptyText: (<StyledButtons type="primary" className="m-3" onClick={() => setOpenModal(true)}>
      {Name}
    </StyledButtons>),
  };

  return (
    <>
      <Table
        className="mb-3"
        dataSource={tabledata}
        columns={columns}
        rowKey="role_id"
        pagination={false}
        locale={customLocale}
      />
      <div className="text-end w-100">
        <StyledButton type="primary" onClick={() => setStep(step - 1)} className="mx-2">
          Back
        </StyledButton>
        {submit ? (
          <StyledButton type="primary" onClick={() => setCreate(true)}>Create</StyledButton>
        ) : (
          <StyledButton
            type="primary"
            disabled={selectedRoleId?.length === 0 || selectedBaseLocation === "" || disable}
            onClick={() => setStep(step + 1)}
          >
            Next
          </StyledButton>
        )}
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  roleList: getRoleList(state),
});
export default connect(mapStateToProps, null)(SelectTable);